// extracted by mini-css-extract-plugin
export default {"geoPagination":"geography-fields-list_geoPagination__vHhWU"};